<template>
  <div class="app-range-slider-container">
    <vue-slider v-model="dataVModel" class="app-range-slider" :min="min" :max="max" :disabled="disabled" tooltip="none"
      contained drag-on-click @drag-end="$emit('validateSlider', dataVModel)" />
    <p v-if="err != null" class="error-msg">
      {{ $t('errors.' + err) }}
    </p>
    <div class="app-range-slider-values">
      <div class="app-range-slider-first-value">
        {{ formatPrice(parseFloat(dataVModel[0]), currency) }}
      </div>
      <div class="app-range-slider-second-value">
        {{ formatPrice(parseFloat(dataVModel[1]), currency) }}
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/material.css'
import { Utils } from '@/mixins/Utils'

export default {
  name: 'RangeSlider',
  components: {
    VueSlider
  },
  mixins: [Utils],
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: 'EUR'
    }
  },
  emits: ['validateSlider', 'input'],
  data() {
    return {
      dataVModel: [this.min, this.max],
      err: null
    }
  },
  watch: {
    dataVModel(newValue) {
      if (newValue[1] < newValue[0]) {
        this.err = 'range_incorrect'
      } else {
        this.err = null
        this.$emit('input', [newValue[0], newValue[1]])
      }
    },
    min() {
      this.dataVModel = [this.min, this.max]
    },
    max() {
      this.dataVModel = [this.min, this.max]
    },
    value(newValue) {
      this.dataVModel = newValue
    }
  }
}
</script>

<style lang="scss">
.app-range-slider-container {
  .app-range-slider {
    .vue-slider-rail {
      background-color: rgb(var(--custom-color-secondary));

      .vue-slider-process {
        background-color: rgb(var(--custom-color-main));
      }

      .vue-slider-dot-handle {
        background-color: rgb(var(--custom-color-main));
      }

      .vue-slider-dot-tooltip-inner {
        background-color: rgb(var(--custom-color-main));
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.app-range-slider-container {
  padding-top: 1rem;

  .app-range-slider-values {
    display: flex;
    justify-content: space-between;
    font-family: MainTitleFont, Helvetica, Arial, sans-serif;

    .app-range-slider-first-value,
    .app-range-slider-second-value {
      margin: 0.5rem;
      padding: 0.25rem;
      background-color: #efefef;
    }
  }
}
</style>
